import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';


class DeleteVersionModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { openModal, closeModal, versionToDelete, handleDeleteVersion, deleteVersionInProgress } = this.props;
    const { activeVersion } = versionToDelete || {};
    return (
      <Modal show={openModal === 'DeleteVersionModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Version</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!activeVersion && (
            <div>
              {!deleteVersionInProgress && (
                <span>Are you sure you want to permanently delete revision {(versionToDelete || {}).versionName}?</span>
              )}
              {deleteVersionInProgress && (
                <span>Loading ...</span>
              )}
            </div>
          )}
          {activeVersion && (
            <span>Unable to delete active version of asset. Please restore another version before deleting</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!activeVersion && (
            <Button type="button" bsStyle="success" onClick={handleDeleteVersion} disabled={deleteVersionInProgress}>
              <span className="ti ti-check" /> Yes, Delete
            </Button>
          )}
          {' '}
          <Button type="button" bsStyle="hollow-info" onClick={closeModal} disabled={deleteVersionInProgress}>
            <span className="ti ti-close" /> Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(DeleteVersionModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/DeleteVersionModal.js